<template>
  <div class="coupon-record-page">
    <a-card :bordered="false" class="coupon-record-card">
      <template slot="title">
        <page-back-title title="派券记录" />
      </template>
      <StandardSearchPageView
        ref="tableWrap"
        rowKey="id"
        :columns="columns"
        :queryParams="queryParams"
        :searchOptions="searchOptions"
        :request-promise="loadList"
        :page-size="10"
        :export-type="2"
        @export="handleExport"
      />
    </a-card>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import PageBackTitle from './components/PageBackTitle.vue'

export default {
  name: 'CouponRecordList',
  components: {
    StandardSearchPageView,
    PageBackTitle
  },
  data () {
    return {
      queryParams: {
        couponCode: this.$route.query.couponCode || '',
        memberMobile: '',
        consumeStatus: undefined
      },
      searchOptions: [
        { name: '优惠券ID', key: 'couponCode', type: 'input', placeholder: '请输入' },
        { name: '用户', key: 'memberMobile', type: 'input', placeholder: '请输入' },
        {
          name: '核销状态',
          key: 'consumeStatus',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '未核销', value: 0 },
            { label: '已核销', value: 1 }
          ]
        }
      ],
      columns: [
        { title: '序号', dataIndex: 'id', width: 100 },
        { title: '用户', dataIndex: 'memberMobile', width: 180 },
        { title: '优惠券ID', dataIndex: 'couponCode', width: 180 },
        { title: '核销状态', dataIndex: 'consumeStatusStr', width: 120 },
        { title: '领取时间', dataIndex: 'createTime', width: 200 },
        { title: '核销时间', dataIndex: 'consumeTime', width: 200 }
      ]
    }
  },
  methods: {
    loadList (requestParams) {
      const { limitDto, couponCode, memberMobile, consumeStatus } = requestParams
      return this.getHttpServices()
        .getNewServeService()
        .post('/couponMember/page', {
          couponCode: couponCode || '',
          memberMobile: memberMobile || '',
          consumeStatus: consumeStatus == null || consumeStatus === '' ? null : Number(consumeStatus),
          limitDto
        })
    },
    handleExport () {
      const table = this.$refs.tableWrap && this.$refs.tableWrap.$refs.tableList
      const pageNum = table ? table.currentPage : 1
      const pageSize = table ? table.currentPageSize : 10
      const { couponCode, memberMobile, consumeStatus } = this.queryParams

      this.getHttpServices()
        .getNewServeService()
        .post('/couponMember/export', {
          couponCode: couponCode || '',
          memberMobile: memberMobile || '',
          consumeStatus: consumeStatus == null || consumeStatus === '' ? null : Number(consumeStatus),
          limitDto: {
            pageNum,
            pageSize
          }
        })
        .then(() => {
          this.$message.success('导出成功，请去报表下载中心下载')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '导出失败，请重试')
        })
    }
  }
}
</script>

<style scoped lang="less">
.coupon-record-page {
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.coupon-record-card {
  height: 100%;
  display: flex;
  flex-direction: column;

  /deep/ .ant-card-head {
    flex-shrink: 0;
  }

  /deep/ .ant-card-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  /deep/ .standard-search-page-view {
    min-height: 0;
  }

  /deep/ .cst-page-table-box {
    height: auto !important;
    flex: 1;
    min-height: 0;
    flex-shrink: 1;
  }

  /deep/ .table-viewport {
    flex-shrink: 1;
    min-height: 0;
  }

  /deep/ .custom-pagination-box {
    flex-shrink: 0;
  }
}
</style>
